export default __webpack_public_path__ + "static/media/Koala.4962d362.png";